import Butter from 'buttercms';

const butter = Butter('14007530e98df328a8462b0f60f49c8d7d83860e');

export default butter;
